import { lowerTimeBound, } from "./ActionRecordRepository";
const initialId = 0;
export class MockActionRecordRepository {
    records;
    subscriptions;
    nextId;
    constructor(records = {}, subscriptions = {}, nextId = initialId) {
        this.records = records;
        this.subscriptions = subscriptions;
        this.nextId = nextId;
    }
    delete(documentUid, actionRecordUid) {
        const records = this.records[documentUid];
        if (records)
            delete records[actionRecordUid];
        return Promise.resolve();
    }
    getAll(documentUid, options) {
        const predicate = this.predicateForRange(options.range);
        const docRecords = this.records[documentUid];
        if (!docRecords) {
            const rawResults = [];
            return Promise.resolve({ records: rawResults, unfilteredCount: 0 });
        }
        // TODO: need to implement limiting behavior here, it's a little tricky when combined with limit
        const rawResults = Object.values(docRecords);
        const filteredResults = rawResults
            .filter(predicate)
            .filter((ar) => (options.includeOnlyVersionIncrementingRecords ? ar.actionUpdatesDocumentVersion : true))
            .sort((ar1, ar2) => ar1.actionTimestamp - ar2.actionTimestamp);
        const sortedResults = options.timeOrder === "forward" ? filteredResults : filteredResults.reverse();
        return Promise.resolve({ records: sortedResults, unfilteredCount: rawResults.length });
    }
    get(documentUid, actionRecordUid) {
        const docRecords = this.records[documentUid];
        if (docRecords) {
            return Promise.resolve(docRecords[actionRecordUid]);
        }
        return Promise.resolve(undefined);
    }
    subscribeToNewActionRecordsForDocumentContext(documentUid, onChange) {
        return Promise.resolve(this.subscribeToNewActionRecords(documentUid, { range: lowerTimeBound(1000000, false) }, onChange));
    }
    getDocumentVersionRelevantActionRecords(documentUid, startPointTS, limit = 50) {
        const options = {
            range: lowerTimeBound(1000000, false),
            maxResults: limit,
            includeOnlyVersionIncrementingRecords: true,
            timeOrder: "forward",
            startPointTS,
        };
        const predicate = this.predicateForRange(options.range);
        const docRecords = this.records[documentUid];
        if (!docRecords) {
            return Promise.resolve({ actionRecords: {}, hasMore: false });
        }
        const filteredResults = Object.fromEntries(Object.values(docRecords)
            .filter(predicate)
            .filter((ar) => (options.includeOnlyVersionIncrementingRecords ? ar.actionUpdatesDocumentVersion : true) &&
            (options.startPointTS ? ar.actionTimestamp > options.startPointTS : true))
            .sort((ar1, ar2) => ar1.actionTimestamp - ar2.actionTimestamp)
            .map((ar) => [ar.actionRecordUid, ar])
            .slice(0, limit));
        return Promise.resolve({
            actionRecords: filteredResults,
            hasMore: Object.values(filteredResults).length >= limit,
        });
    }
    subscribeToNewActionRecords(documentUid, options, onChange) {
        const id = this.nextId;
        this.nextId += 1;
        this.subscriptions[id] = {
            id,
            documentUid,
            range: options.range,
            callback: onChange,
        };
        return () => {
            this.unsubscribeFromChanges(id);
        };
    }
    // TODO: implement clientId
    save(documentUid, actionRecord, _clientId) {
        const records = this.getOrCreateRecordsForUid(documentUid);
        records[actionRecord.actionRecordUid] = actionRecord;
        return Promise.resolve();
    }
    getOrCreateRecordsForUid(documentUid) {
        const result = this.records[documentUid];
        if (result)
            return result;
        else {
            this.records[documentUid] = {};
            // This is dumb, isn't there a better way to do this
            return this.records[documentUid];
        }
    }
    unsubscribeFromChanges(subscriptionId) {
        delete this.subscriptions[subscriptionId];
    }
    predicateForRange(range) {
        if (!range)
            return (_ar) => true;
        else {
            switch (range.type) {
                case "lower": {
                    return (ar) => {
                        if (range.lowerBound.inclusive)
                            return ar.actionTimestamp >= range.lowerBound.timestamp;
                        return ar.actionTimestamp > range.lowerBound.timestamp;
                    };
                }
                case "upper": {
                    return (ar) => {
                        if (range.upperBound.inclusive)
                            return ar.actionTimestamp >= range.upperBound.timestamp;
                        return ar.actionTimestamp > range.upperBound.timestamp;
                    };
                }
                case "interval": {
                    return (ar) => {
                        const upper = range.upperBound.inclusive
                            ? ar.actionTimestamp >= range.upperBound.timestamp
                            : ar.actionTimestamp > range.upperBound.timestamp;
                        const lower = range.lowerBound.inclusive
                            ? ar.actionTimestamp <= range.lowerBound.timestamp
                            : ar.actionTimestamp < range.lowerBound.timestamp;
                        return upper && lower;
                    };
                }
            }
        }
    }
}
//# sourceMappingURL=MockActionRecordRepository.js.map